import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';
import { BlockingReasonVariant } from './_types';

export function RequiredFormReason({
  actions,
  resolved = false,
  variant: _variant = 'checkin',
}: {
  actions?: ButtonPropsWithLabel[];
  resolved?: boolean;
  variant?: BlockingReasonVariant;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={t('blockingReasons.formsRequired.title')}
      message={t('blockingReasons.formsRequired.message')}
      actions={resolved ? undefined : actions}
      color={resolved ? 'success' : 'error'}
    />
  );
}
